module.exports = __webpack_public_path__ + "img/icon_exclamation_mark_w.63b049e8.svg";